<ng-container *ngIf="!hasThumbnailError; else errorTemplate">
	<a href="{{ product.ImageUrl }}" target="_blank">
		<img class="image-size" [src]="product.ThumbnailUrl" (error)="hasThumbnailError = true" />
	</a>
</ng-container>
<ng-template #errorTemplate>
	<i class="mdi mdi-image-multiple-outline"></i>
</ng-template>
